import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

import { hashMD5 } from '../../../../components/Auth/AuthUtils';

import { dataAtualFormatada, horaAtualFormatada } from '../../../../util/FuncoesComuns';

import IUnidadeUnitizadoresItensGeralAlerta from '../../interfaces/IUnidadeUnitizadoresItensGeralAlerta';
import { imageLogoEctSVG } from '../../../../util/SVGConstants';

const getPdfToBase64 = async (pdfDoc: any) => {
    return new Promise(resolve => {
        pdfDoc.getBase64((base: any) => {
            resolve(base);
        });
    })
}

let hash='';

const downloadAnaliticoExcluidosPdf = async (unitizadores: IUnidadeUnitizadoresItensGeralAlerta[], usuario: any, filtro: string, idHash: string) => {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

    const dataIniAno = dataAtualFormatada('ano', '-');
    const data = dataAtualFormatada('dia', '/');
    const hora = horaAtualFormatada();

    let totais = {
        qtdLinhas: 0
    }

    let nomeArquivo = `ROE_${unitizadores[0].codSroOrigem}_${usuario.unidadeSro.codigoSro}_${data.replaceAll('/', '')}.pdf`;
    const unidade = `Unidade: ${usuario.unidadeSro.codigoSro} - ${usuario.unidadeSro.nome}/${usuario.unidadeSro.superintendencia.sigla}`;
    const usuarioMatriculaNome = `Usuário: ${usuario.sub} - ${usuario.nome}`;
    hash = !idHash ? hashMD5(`${usuario.unidadeSro.codigoSro}${usuario.sub}${data} ${hora}${unitizadores.length}`).toString() : idHash;

    const reportTitle: any = [
        [{
            margin: [25, 25, 25, 5],
            headerRows: 1,
            table: {
                widths: [176, 412, 180],
                body: [
                    [
                        {
                            svg: imageLogoEctSVG,
                            height: 16,
                            width: 110,
                            alignment: 'center',
                        },
                        {
                            text: 'CONFERÊNCIA ELETRÔNICA',
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                        },
                        {
                            text: `Data: ${data} Hora: ${hora}`,
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                        }
                    ]
                ]
            }
        },
        {
            margin: [25, 3, 25, 5],
            headerRows: 1,
            table: {
                widths: [300, 478],
                body: [[
                    {
                        text: unidade,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: `Filtro: ${filtro}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
        },
        {
            margin: [25, 3, 5, 3],
            headerRows: 1,
            table: {
                widths: [235, 298, 235],
                body: [[
                    {
                        text: 'Relatório: EXCLUÍDOS',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: usuarioMatriculaNome,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: 'Conferente:',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
        }
        ]
    ];

    const dados = unitizadores.map((uni) => {

        totais.qtdLinhas++;

        return [
            { text: uni.seOrigem, fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.codSroOrigem, fontSize: 7.3, margin: [0, 0, 0, 0] },
            { text: uni.dataExpedicao, fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.dataRecebido, fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.numUnitizador, fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.objeto || ' ', fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.carga || ' ', fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.dataAlterado || ' ', fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.matricula || ' ', fontSize: 7.5, margin: [0, 0, 0, 0] },
            { text: uni.codMotivo && uni.codMotivo === 69 ? 'Excluido da Falta por Extravio' : uni.codMotivo || ' ', fontSize: 7.5, margin: [0, 0, 0, 0] }
        ]
    });

    let qtdListas = totais.qtdLinhas <= 1 ? `    ${totais.qtdLinhas} Objeto/Unitizador.` : `    ${totais.qtdLinhas} Objetos/Unitizadores.`
    const detailsTotais: any = [
        { colSpan: 10, text: qtdListas, fontSize: 9, margin: [34, 0, 0, 0], alignment: 'left', bold: true, border: [true, true, true, true] }
    ];

    dados.push(detailsTotais);

    const details: any = [
        {
            table: {
                headerRows: 1,
                widths: [16, 40, 72, 72, 60, 60, 25, 72, 40, 190],
                body: [
                    [
                        { text: 'SE', style: 'tableHeader', fontSize: 9 },
                        { text: 'Origem', style: 'tableHeader', fontSize: 9 },
                        { text: 'Enviado', style: 'tableHeader', fontSize: 9 },
                        { text: 'Recebido', style: 'tableHeader', fontSize: 9 },
                        { text: 'Englobador', style: 'tableHeader', fontSize: 9 },
                        { text: 'Objetos', style: 'tableHeader', fontSize: 9 },
                        { text: 'Carga', style: 'tableHeader', fontSize: 9 },
                        { text: 'Data Exclusão', style: 'tableHeader', fontSize: 9 },
                        { text: 'Matrícula', style: 'tableHeader', fontSize: 9 },
                        { text: 'Motivo', style: 'tableHeader', fontSize: 9 }
                    ],
                    ...dados
                ]
            },
            margin: [13, 5, 25, 5],
            layout: 'lightHorizontalLines' // headerLineOnly
        }
    ];

    function Rodape(currentPage: Number, pageCount: Number) {

        return [
            {
                widths: [768],
                margin: [25, 5, 25, 5],
                headerRows: 1,
                columns: [{
                    text: `Identificador documento: ${hash}`,
                    alignment: 'left',
                    fontSize: 9,
                },
                {
                    text: `Página ${currentPage} de ${pageCount}`,
                    alignment: 'right',
                    fontSize: 9,
                }]
            }
        ]
    }

    const docDefinitios: any = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [15, 105, 15, 30],
        header: [reportTitle],
        content: [details],
        footer: Rodape
    }


    let pdf = pdfMake.createPdf(docDefinitios);

    let retorno: any = {
        id: hash,
        codSroOrigem: unitizadores[0].codSroOrigem,
        codSroDestino: usuario.unidadeSro.codigoSro,
        matriculaUsuario: usuario.sub,
        dtHrCriacao: `${dataIniAno}T${hora}`,
        nomeDocumento: nomeArquivo,
        pdfDocumento: {
            hash: hash,
            data: data,
            hora: hora,
            totais: totais,
            unidade: unidade,
            filtro: filtro,
            usuarioMatriculaNome: usuarioMatriculaNome,
            usuario: usuario,
            dados: dados,
            unitizadores: unitizadores
        }
    };
    retorno.pdfDocumento = await getPdfToBase64(pdf);

    pdf.download(nomeArquivo);

    return retorno;
}

export default downloadAnaliticoExcluidosPdf;